import { useNavigate } from "react-router-dom";
import { animated, useSpring } from "@react-spring/web";
import { useState } from "react";
import CompanyContactModal from "../components/companyContactModal";

const PartEight = () => {
  const navigate = useNavigate();

  const [showFormModal, setShowFormModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeAccordions, setActiveAccordions] = useState({});


  const toggleAccordion = (cardIndex, accordionIndex) => {
  const key = `${cardIndex}-${accordionIndex}`;

  setActiveAccordions((prev) => {
    const isCurrentlyOpen = prev[key];
    return isCurrentlyOpen ? {} : { [key]: true };
    });
};
  const spring = useSpring({
    from: { y: 20, opacity: 0 },
    to: { y: 0, opacity: 1 },
  });

  const subscriptionData = [
    {
      title: "Tutors",
      buttonText: "Start exploring",
      bgColor: "#686466",
      titleColor: "white",
      textColor: "white",
      textClass: "text-left p-3 rounded text-white",
      accordions: [
        {
          title: "AI Assignment Assistance",
          text: "AI tools help create, grade, and provide feedback on assignments, saving time and enhancing the learning experience for students.",
        },
        {
          title: "Professional Development",
          text: "Access to tech-savvy courses specifically designed for educators, focusing on the latest educational technologies and teaching methodologies.",
        },
        {
          title: "Community and Support",
          text: "A dedicated support system and a community of like-minded educators for sharing resources and best practices.",
        },
      ],
    },
    {
      title: "Students",
      buttonText: "Sign up",
      bgColor: "white",
      titleColor: "black",
      textColor: "black",
      textClass: "text-left border border-gray-200 p-3 rounded text-black",
      accordions: [
        {
          title: "Personalized Learning Paths",
          text: "AI-driven recommendations for courses and study materials based on individual learning styles and goals.",
        },
        {
          title: "Multimedia Resources",
          text: "Access to a vast library of video, audio, and interactive content designed to cater to diverse learning preferences.",
        },
        {
          title: "AI-Powered Study Aids",
          text: "Tools like flashcards, summaries, and practice quizzes tailored to each student's needs, enhancing retention and understanding.",
        },
      ],
    },
  ];

  // const accordionData = [
  //   {
  //     title: "Student",
  //     buttonText: "Start exploring",
  //     accordions: [
  //       {
  //         title: "Tailored Learning",
  //         text: "Enjoy personalized education based on your unique learning matrix, resulting in efficient and rewarding learning experiences.",
  //       },
  //       {
  //         title: "Qualified Tutors",
  //         text: "Access an array of vetted tutors in various subjects, finding the perfect match for your educational needs.",
  //       },
  //       {
  //         title: "24/7 Study Support",
  //         text: "With AI-powered ChatGPT, get round-the-clock study assistance and concept clarification.",
  //       },
  //       {
  //         title: "Accessible Learning Material",
  //         text: "Use dynamic learning resources and assignments custom-made for your learning requirements.",
  //       },
  //       {
  //         title: "Interact and Grow",
  //         text: "Learn and interact within a community of students sharing knowledge and experiences.",
  //       },
  //       {
  //         title: "Free and Seamless",
  //         text: "Enjoy a user-friendly platform with no additional cost beyond your tutor's fees. Single sign-on feature and integrated communication tools offer a smooth and hassle-free learning experience.",
  //       },
  //     ],
  //   },
  //   {
  //     title: "Parent",
  //     buttonText: "Join now",
  //     accordions: [
  //       {
  //         title: "Progress Tracking",
  //         text: "Keep a tab on your child's academic growth and understand their learning patterns.",
  //       },
  //       {
  //         title: "Parental Control",
  //         text: "Get access to an integrated dashboard providing updates on your child's educational progress.",
  //       },
  //       {
  //         title: "Quality Education",
  //         text: "Ensure top-notch education for your child from our network of proficient tutors.",
  //       },
  //       {
  //         title: "Secure Learning",
  //         text: "Rest easy with a trustworthy platform that prioritizes your child's safety.",
  //       },
  //       {
  //         title: "Personalized Learning Plans",
  //         text: "Experience learning plans tailored specifically to your child's needs and learning style.",
  //       },
  //       {
  //         title: "Free and Integrated",
  //         text: "Use our platform at no extra cost with the convenience of single sign-on, and benefit from community support and shared experiences.",
  //       },
  //     ],
  //   },
  //   {
  //     title: "Tutor",
  //     buttonText: "Become a Member",
  //     accordions: [
  //       {
  //         title: "Wide Student Base",
  //         text: "Connect with a diverse range of students seeking your expertise.",
  //       },
  //       {
  //         title: "Organized Scheduling",
  //         text: "Manage your tutoring sessions efficiently with our integrated calendar and booking system.",
  //       },
  //       {
  //         title: "Innovative Tools",
  //         text: "Benefit from tools like automatic assignment generation and AI assistance for effective teaching.",
  //       },
  //       {
  //         title: "Professional Development",
  //         text: "Expand your tutoring practice and skillset while benefiting from just a 10% fee on your income.",
  //       },
  //       {
  //         title: "Community Engagement",
  //         text: "Share and gain teaching strategies within a community of fellow tutors.",
  //       },
  //       {
  //         title: "Secure Payments",
  //         text: "Enjoy seamless, timely, and secure payment transactions.",
  //       },
  //     ],
  //   },
  //   {
  //     title: "SwotBuddy",
  //     buttonText: "Sign up free",
  //     accordions: [
  //       {
  //         title: "Mentorship Role",
  //         text: "Enhance students' learning journeys and contribute meaningfully to their academic success.",
  //       },
  //       {
  //         title: "Engaging Community",
  //         text: "Be part of a vibrant community of swotbuddies, tutors, students, and parents.",
  //       },
  //       {
  //         title: "Skill Enhancement",
  //         text: "Improve your mentoring skills and gain experience in the education technology sector.",
  //       },
  //       {
  //         title: "Valuable Experience",
  //         text: "Acquire rewarding experiences in the ed-tech field, adding value to your professional growth.",
  //       },
  //       {
  //         title: "Flexibility",
  //         text: "Work at your own pace with a role that suits your schedule and commitment level.",
  //       },
  //       {
  //         title: "Making a Difference",
  //         text: "Play a direct role in shaping students' educational journey and success.",
  //       },
  //     ],
  //   },
  // ];

  return (
    <div className="mt-20 mb-36" id="enroll">
      <p className="text-3xl text-gray-600 mb-14 text-center">Subscription</p>

      <div className="flex justify-center align-center gap-8 flex-wrap">
        {subscriptionData.map((card, cardIndex) => (
          <animated.div
            key={cardIndex}
            className="h-[40rem] card flex flex-col justify-around items-center md:items-start rounded-sm p-6 w-[340px] shadow-md overflow-y-auto"
            style={{
              ...spring,
              backgroundColor: card.bgColor,
            }}
          >
            <p
              className={`rounded-2xl text-xl text-center w-full px-2 py-5 text-${card.titleColor} flex justify-center items-center`}
            >
              {card.title}
            </p>

            {/* Accordion implementation */}
            <div className="w-full">
              {card.accordions.map((accordion, accordionIndex) => (
                <div key={accordionIndex} className="mb-4">
                  <button
                    className={`w-full text-left p-3 border-b focus:outline-none transition-colors duration-500 text-${card.textColor}`}
                    onClick={() => toggleAccordion(cardIndex, accordionIndex)}
                  >
                    {accordion.title}
                    <span className="float-right">
                      {activeAccordions[`${cardIndex}-${accordionIndex}`]
                        ? "−"
                        : "+"}
                    </span>
                  </button>
                  <div
                    className="overflow-hidden transition-all duration-500 ease-in-out"
                    style={{
                      maxHeight: activeAccordions[
                        `${cardIndex}-${accordionIndex}`
                      ]
                        ? "500px"
                        : "0",
                      opacity: activeAccordions[
                        `${cardIndex}-${accordionIndex}`
                      ]
                        ? 1
                        : 0,
                    }}
                  >
                    <div className={card.textClass}>{accordion.text}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="w-full flex items-center justify-center">
              <button
                onClick={() => {
                  if (cardIndex >= 2) {
                    setShowFormModal(true);
                  } else {
                    navigate("/on-boarding");
                  }
                }}
                className="bg-[#B1E1E9] mt-12 md:mt-20 w-fit px-6 py-2 text-white rounded-md shadow-md"
              >
                {card.buttonText}
              </button>
            </div>
          </animated.div>
        ))}
      </div>

      <CompanyContactModal
        ariaHideApp={false}
        isOpen={!loading && showFormModal}
        onRequestClose={() => {
          setShowFormModal(false);
        }}
        showLoader={(status) => {
          setLoading(status);
        }}
      />
    </div>
  );
};

export default PartEight;